import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const FinalCTA = () => {
  return (
    <section className="section bg-gradient-to-r from-primary-500 to-accent-500 text-white">
      <div className="container">
        <motion.div
          className="text-center max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Start screening smarter today
          </h2>
          
          <p className="text-lg mb-8 opacity-90">
            Spin up your first 10 interviews free. No credit card required.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/demo" 
              className="btn bg-white/10 text-white border-white/20 hover:bg-white/20"
            >
              Book a Demo
            </Link>
            <Link 
              to="/demo" 
              className="btn bg-white text-primary-500 border-white hover:bg-gray-50"
            >
              Start Free
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default FinalCTA
